import './BetbookPostDetailHeader.less';

import React, { ReactNode } from 'react';
import BetbookBackIcon from '../../icons/svg/betbook-back-icon-sv.svg';
import clsx from 'clsx';
import BetbookOptionsButtonPortal, { BetbookOptionsButtonMobile } from '../betbook-options-button/BetbookOptionsButton';
import { nuiCtx } from '../../common/initialization';

export interface BetbookPostDetailHeaderProps {
    onOptionButton?: (any) => void;
    optionContent?: ReactNode;
    showOptionsButton?: boolean;
    sportId: string | number;
    title?: string;
}

export default function BetbookPostDetailHeader({
    onOptionButton,
    optionContent,
    showOptionsButton = false,
    sportId,
    title
}: BetbookPostDetailHeaderProps) {
    function onBackButton() {
        nuiCtx.routing.history_back();
    }
    return (
        <div className={clsx('betbook-detail-header', `bg-${sportId}`)}>
            <div className="betbook-detail-header-info">
                <div
                    className="betbook-detail-header-back-button flex"
                    data-atid="analysis-go-back"
                    onClick={onBackButton}
                >
                    <BetbookBackIcon />
                </div>
                {title && <div className="betbook-detail-header-title">{title}</div>}
                {showOptionsButton ? (
                    optionContent ? (
                        <BetbookOptionsButtonPortal content={optionContent} className="betbook-detail-popup" />
                    ) : (
                        <BetbookOptionsButtonMobile onClick={onOptionButton} />
                    )
                ) : (
                    <div className="betbook-option-button" />
                )}
            </div>
        </div>
    );
}
